
<div class="header-toolbar">
  <h1>{{ title }}</h1>
</div>

<form #form="ngForm" (ngSubmit)="save()" autocomplete="off" *ngIf="user">

  <!-- Toolbar -->
  <div class="main btn-toolbar">
        
    <button class="btn" type="submit" [disabled]="!user.valid">
      <t-icon name="check"></t-icon>
      <span class="text">Enregistrer</span>
    </button>

    &nbsp;

    <a class="btn" (click)="cancel()">
      <t-icon name="close"></t-icon>
      <span class="text">Annuler</span>
    </a>

  </div>
  <!-- /Toolbar -->

  <div class="grid" *ngIf="user">

    <div class="column">

      <t-user-auth [user]="user"></t-user-auth>

      <t-user-details [user]="user"></t-user-details>
      
    </div>

    <div class="column">

      <t-user-admin [user]="user" *ngIf="mode === 'new' || mode === 'edit'"></t-user-admin>

      <t-user-extras [user]="user" *ngIf="mode === 'edit'"></t-user-extras>

    </div>

  </div>
</form>